module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/photo01-e98b8f04bea42234234384aa09112286.png";